import React from 'react';
import { Outlet } from 'react-router-dom';
import Login from './Login/Login';
import Footer from './SharedComponents/Footer/Footer';
import Header from './SharedComponents/Header/Header';
import LeftsideBar from './SharedComponents/LeftsideBar/LeftsideBar';
import RightsideBar from './SharedComponents/RightsideBar/RightsideBar';

const MainOutlet = () => {
  return (
    <div className='mx-2 md:mx-4 xl:mx-0'>
      <Header></Header>
        <div className='grid md:grid-cols-4 gap-4 my-6 max-w-screen-xl mx-auto'>
          <LeftsideBar></LeftsideBar>
          <Outlet></Outlet>
          <RightsideBar></RightsideBar>    
        </div>
      <Footer></Footer>
    </div>
  );
};

export default MainOutlet;